import { useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';
import { LoadingContext, M_StateActions, MTabsInpage, NavigateContext } from 'src/M_Components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import MarketConfig from './marketConfig';
import MarketConfigCrud from './marketConfigCrud';

export default function MarketPage({ roles, onCreateTab, toastMessages, handleTabClose }) {
    const ctx = useContext(LoadingContext);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const matches = useMediaQuery('(min-width:900px)');
    const M_State = useSelector((state) => state.StateKeyValue);
    const location = useLocation();
    const { renameTab } = useContext(NavigateContext);
    const selectedTab = useSelector(s => s.StateKeyValue.find(o => o.key === 'selectedTab')?.value);

    const [menu, setMenu] = useState(1);
    const [selectedMarket, setSelectedMarket] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [id, setId] = useState(() => M_State.find(obj => obj.key === 'selectedTab')?.value || 'market');

    const sessionKeys = ['menu', 'selectedMarket', 'refresh'];

    //============================================================================================================
    // EFFECT
    // Rename tab when selectedTab changes
    //============================================================================================================
    useEffect(() => {
        if (!selectedTab) return; // Exit if selectedTab is not defined
        renameTab(String(selectedTab), t('Markets'));
    }, [t, selectedTab]);

    //============================================================================================================
    // Function to handle session storage data
    //============================================================================================================
    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true);
        const session = M_State.find(obj => obj.key === sessionID)?.value;
        if (session) {
            const m = session.find(x => x.key === 'menu')?.value;
            const mk = session.find(x => x.key === 'selectedMarket')?.value;
            const ref = session.find(x => x.key === 'refresh')?.value;
            if (m) setMenu(m);
            if (mk) setSelectedMarket(mk);
            if (ref !== undefined) setRefresh(ref);
        }
        ctx.setIsLoad(false);
    };


    //============================================================================================================
    // EFFECT
    // Load session data on initial render
    //============================================================================================================
    useEffect(() => {
        getSessionStorageData(id); // Load session data on initial render
        setRefresh(r => !r); // Trigger a refresh to ensure the latest data is loaded
    }, [location.pathname]);

    //============================================================================================================
    // EFFECT
    // Save session data on state changes
    //============================================================================================================
    useEffect(() => {
        const values = { menu, selectedMarket, refresh }; // Collect current state values
        const sessionData = sessionKeys.map(k => ({ key: k, value: values[k] })); // Prepare data for session storage
        dispatch(M_StateActions.addM_State({ key: id, value: sessionData })); // Save to Redux store
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, menu, selectedMarket, refresh]);


    return (
        <div className="divGlobalSettings">
            <div>
                <Routes>
                    <Route index element={
                        <MarketConfig // Main market configuration component with the dynamic table
                            roles={roles}
                            onCreateTab={onCreateTab}
                            toastMessages={toastMessages}
                            selectedMarket={selectedMarket}
                            setSelectedMarket={setSelectedMarket}
                            refresh={refresh}
                            setRefresh={setRefresh}
                        />
                    } />
                    <Route path='marketConfigCrud' element={
                        <MarketConfigCrud // Component for creating or editing market configurations
                            handleTabClose={handleTabClose}
                            toastMessages={toastMessages}
                        />
                    } />
                </Routes>
            </div>
        </div>

    );
}
